// extracted by mini-css-extract-plugin
export default {"snackbar":"SnackBar_snackbar__Alw7Z","button":"SnackBar_button__05pgo"};